// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f52644d7","185":"5775998a"}[chunkId] + ".chunk.css";
};